import React from 'react';
import { Link } from 'react-router-dom';

const SigninModal = ({ handleClose, show }) => {
  
  const showHideClassName = show ? 'modal show' : 'modal hide';

  return(
    <div className={showHideClassName}>
      <div className="content create">
        <button className="close" onClick={handleClose}>
          <i className="fa fa-angle-right"></i>
          <i className="fa fa-angle-left"></i>
        </button>
        <form>
          <h3 className="title">Not Signed In</h3>
          <br />
          <h4 className="">Sign in to manage your projects</h4>
          <br />
          <p>
            <Link className="btn" to="/signin" >Sign In</Link>
          </p>
        </form>
      </div>
    </div>
  );
}

export default SigninModal;


// WEBPACK FOOTER //
// ./src/components/SigninModal.js